import React from 'react'

const SearchIcon: React.FC = () => (
  <span className='font-icon-input-label'>
    <i className='far fa-search' aria-hidden='true' />
  </span>
)
export default SearchIcon
